/**
 * @file accordion
 *
 * @module accordion
 *
 */

import $ from 'jquery';

(function($) {
  'use strict';

  var config = {
    accordion  : '.js-accordion',
  };

  /**
   * Extends the accordion object functions responsible for the accordions display behaviors
   * @memberof module:accordion
   */

  function fpiAccordion() {
    $(config.accordion).accordion();
  }

  // init
  $(document).ready(function() {
    fpiAccordion();
  });

})($);



// WEBPACK FOOTER //
// ./src/js/modules/accordion.js